import React from "react";
import { HiQueueList } from "react-icons/hi2";
import { HiViewList } from "react-icons/hi";
import { BsFillChatSquareTextFill } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import { IconType } from "react-icons";
import { TbMessage2Star } from "react-icons/tb";
import { TbUserStar } from "react-icons/tb";
import { QuestionOptionType } from "survey";

type QuestionOption = {
  icon: IconType;
  text: string;
  type: QuestionOptionType;
};

export const QuestionOptions: QuestionOption[] = [
  { icon: BsFillChatSquareTextFill, text: "Tekst", type: "free-text" },
  { icon: HiQueueList, text: "Pojedyńczy wybór", type: "single-select" },
  { icon: HiViewList, text: "Wielokrotny wybór", type: "multi-select" },
  { icon: FaStar, text: "Ocena 1-5", type: "rating" },
  { icon: TbMessage2Star, text: "Ocena kursu", type: "course-rating" },
  { icon: TbUserStar, text: "Ocena trenera", type: "trainer-rating" },
];

interface AddQuestionBodyProps {
  onClick: (type: QuestionOptionType) => void;
  options: QuestionOptionType[];
}
export const AddQuestionBody = ({ options, onClick }: AddQuestionBodyProps) => {
  return (
    <div className="bg-white justify-left flex flex-col pt-2 dark:bg-slate-800">
      <AddQuestionOptions
        onClick={onClick}
        options={QuestionOptions.filter((option) => options.includes(option.type))}
      />
    </div>
  );
};

interface AddQuestionOptionsProps {
  onClick: (type: QuestionOptionType) => void;
  options: QuestionOption[];
}
const AddQuestionOptions = ({ onClick, options }: AddQuestionOptionsProps) => {
  return options.map((option) => (
    <button
      key={option.type}
      type="button"
      onClick={() => onClick(option.type)}
      className="mx-2 inline-flex items-center rounded p-0.5 px-4 py-2 font-medium text-slate-700 last:mb-2 hover:bg-slate-100 hover:text-slate-800 dark:text-slate-300 dark:hover:bg-slate-700 dark:hover:text-slate-100"
    >
      <option.icon className="text-emerald-500" />

      <span className="ml-2 text-sm">{option.text}</span>
    </button>
  ));
};
